const MAP = {
  paid: "chip-paid",
  pending: "chip-pending",
  overdue: "chip-overdue",
  blocked: "chip-blocked",
  hold: "chip-hold",
  info: "chip-info",
  none: "chip-neutral",
  neutral: "chip-neutral",
};

export function StatusChip({ label, tone = "neutral", testid }) {
  return (
    <span data-testid={testid} className={`chip ${MAP[tone] || MAP.neutral}`}>
      {label}
    </span>
  );
}

export const riderStatusTone = (s) =>
  s === "Active" ? "paid" : s === "Swap Blocked" ? "blocked" : "neutral";

export const batteryStatusTone = (s) =>
  s === "Available" ? "paid" : s === "In Use" ? "info" : s === "On Hold" ? "hold" : "overdue";

export const vehicleStatusTone = (s) =>
  s === "Assigned" ? "info" : s === "Unassigned" ? "paid" : "pending";

export const invoiceStatusTone = (s) =>
  s === "Paid" ? "paid" : s === "Overdue" ? "overdue" : "pending";
